module.exports = __webpack_public_path__ + "img/packages/v4.0b3634.png";